import { IMenuItem } from '../../models/menu.model';

/**
 * Menu configuration for Product Desk.
 * Contains menu items for product license management.
 */
export const productMenu: IMenuItem = {
  label: `Product Desk`,
  path: `product-desk`,
  id: 'MID_PRODUCT_DESK',
  icon: 'fa fa-box',
  children: [
    { path: `license`, label: `Product License`, id: 'MID_PRODUCT_LICENSE' },
    { path: `approved-products`, label: `Approved Products`, id: 'MID_PRODUCT_APPROVED' },
  ],
};
